import React from "react";
import { NavLink } from "react-router-dom";
import "../styles/Tabs.css"; // Import styles

function Tabs() {
    return (
        <div className="tab-bar">

            <NavLink to="/upcoming" className="tab" activeClassName="active">
                UPCOMING TALKSHOW
            </NavLink>
            <NavLink to="/news" className="tab" activeClassName="active">
                COMPLETED TALKSHOW
            </NavLink>
        </div>
    );
}

export default Tabs;
